import { Generic } from './Container';
export function isContainer(node) {
    return node !== null && typeof node === 'object' && node instanceof Generic;
}
export default isContainer;    //# sourceMappingURL=isContainer.js.map
